import { observable, computed, runInAction, action } from 'mobx';
import { canUseDOM } from 'sletat-common-utils/lib/canUseDOM';

import { HotelDetailsStore } from './hotel-details';
import { HotelReviewsStore } from './hotel-reviews';
import { ToursStore } from './tours';
import { SearchFormStore } from './search-form';
import { MainStore } from './main';
import { UiStore } from './ui';
import { InitialState } from 'sletat-api-services/lib/sletat/models/initial-state';
import { HotelPageModel } from 'sletat-api-services/lib/sletat/models/initial-state/page-models/hotel';
import { InitialStateStore } from './initial-state';
import { HotelPageMetaProps } from '../components/HotelPage/HotelPage';

export class HotelPageStores {
    @observable
    private _hotelDetailsStore: HotelDetailsStore;

    @observable
    private _hotelReviewsStore: HotelReviewsStore;

    @observable
    private _toursStore: ToursStore;

    @observable
    private _searchFormStore: SearchFormStore;

    @observable
    private _mainStore: MainStore;

    @observable
    private _uiStore: UiStore;

    @observable
    private _initialStateStore: InitialStateStore;

    constructor() {
        this._initialStateStore = new InitialStateStore();
        this._hotelDetailsStore = new HotelDetailsStore(this._initialStateStore);
        this._hotelReviewsStore = new HotelReviewsStore(this._initialStateStore);
        this._searchFormStore = new SearchFormStore(this._hotelDetailsStore, this._initialStateStore, this);
        this._uiStore = new UiStore();
        this._toursStore = new ToursStore(
            this._searchFormStore,
            this._uiStore,
            this.initialStateStore
        );
        this._mainStore = new MainStore(this._searchFormStore);
    }

    @computed
    get initialStateStore(): InitialStateStore {
        return this._initialStateStore;
    }

    @computed
    get hotelDetails(): HotelDetailsStore {
        return this._hotelDetailsStore;
    }

    @computed
    get hotelReviews(): HotelReviewsStore {
        return this._hotelReviewsStore;
    }

    @computed
    get tours(): ToursStore {
        return this._toursStore;
    }

    @computed
    get searchForm(): SearchFormStore {
        return this._searchFormStore;
    }

    @computed
    get main(): MainStore {
        return this._mainStore;
    }

    @computed
    get ui(): UiStore {
        return this._uiStore;
    }

    /**
     * Этот хак устанавливает initial-state для ssr
     * @param initialState Initial-state that is fetched by the server
     */
    @action
    setSsrInitialState(
        initialState: InitialState<HotelPageModel>,
        additionalProps: HotelPageMetaProps | undefined) {
        this._initialStateStore.setSsrInitialState(initialState, additionalProps);
        this._hotelDetailsStore.setSsrInitialStateStore(this.initialStateStore);
        this._searchFormStore.setSsrInitialStateStore(this.initialStateStore);
        this._hotelReviewsStore.setSsrInitialStateStore(
            this.initialStateStore
        );
    }

    async startSearch() {
        this.ui.notification.hide();
        this.tours.stopSearch();
        runInAction(
            () =>
            (this._toursStore = new ToursStore(
                this.searchForm,
                this.ui,
                this.initialStateStore
            ))
        );

        this.searchForm.showSearchFormBtnLoader();
        this._toursStore.loadTours();
    }
}

const stores = new HotelPageStores();

export const useHotelPageStore = () => stores;

if (canUseDOM && process.env.NODE_ENV !== 'production') {
    window['__SLETAT_STORES__'] = stores;
}

export default stores;
